import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppUpdateService } from '@app/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  currentUser;

  constructor(private translate: TranslateService, private appUpdateService: AppUpdateService) {
    translate.setDefaultLang('fr');
    translate.use('fr');
  }

  ngOnInit() {
    this.appUpdateService.initRefreshApp();
  }
}
